<div class="md-form form-inline form-group">
  <mat-form-field class="rule-type-input">
    <mat-label>Source Environment</mat-label>
    <mat-select (selectionChange)="selectEnvironment($event)" [value]="selectedEnvironment" placeholder="Select">
      <mat-option *ngFor="let opt of environments" [value]="opt" [title]="opt.description">{{opt.display}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
